export const languages = [
  { code: 'es', name: 'Español', html: 'es-CO', og: 'es_CO' },
  { code: 'en', name: 'English', html: 'en', og: 'en_US' },
  { code: 'zh', name: '中文', html: 'zh-Hans', og: 'zh_CN' },
  { code: 'ru', name: 'Русский', html: 'ru', og: 'ru_RU' },
  { code: 'de', name: 'Deutsch', html: 'de', og: 'de_DE' },
  { code: 'fr', name: 'Français', html: 'fr', og: 'fr_FR' },
];
export function splitLanguagePath(pathname) {
  const match = pathname.match(/^\/(en|zh|ru|de|fr)(?=\/|$)/);
  return { language: match?.[1] || 'es', path: match ? pathname.slice(match[0].length) || '/' : pathname };
}
export function languagePath(destination, language = 'es') {
  if (typeof destination !== 'string' || !destination.startsWith('/') || destination.startsWith('//') || /^\/(assets|legal|out\.php)(\/|$)/.test(destination)) return destination;
  const base = splitLanguagePath(destination).path;
  return language === 'es' ? base : `/${language}${base === '/' ? '' : base}`;
}
